/**
 * Starting the Kriegsakademie: a single-player match on a fixed, legible theatre — small map,
 * one recruit opponent, speed I, clock stopped — with the instructor's card on top.
 */
import type { SessionConfig } from '@friction/engine';
import { gameStore } from '../game/store';
import { startSinglePlayer } from '../net/lobby';
import { tutorialStore } from './store';

/**
 * Chosen by surveying seeds with the engine: a compact front where the HQ's telephone ring
 * covers part of the line (so both telephone and courier orders happen), enemy contacts in sight
 * from the first hour, balanced victory points, and a recruit who does not attack for a day.
 * Summer: fair skies and firm ground, so no morning fog hides the enemy in the first lessons.
 */
export const ACADEMY_SEED = 6;

export const ACADEMY_CONFIG: SessionConfig = {
  seed: ACADEMY_SEED,
  mapSize: 'small',
  factions: [{ controller: 'human' }, { controller: 'ai', aiDifficulty: 'recruit' }],
  dayLimit: 0,
  vpVictoryShare: 0.6,
  season: 'summer',
};

export function startAcademy(seed = ACADEMY_SEED): void {
  tutorialStore.getState().begin();
  startSinglePlayer({ ...ACADEMY_CONFIG, seed }, 1, { paused: true });
  // The lessons live and die with their match: leaving it closes the instructor's card.
  const off = gameStore.subscribe((st, prev) => {
    if (st.view || !prev.view) return;
    off();
    if (tutorialStore.getState().active) tutorialStore.getState().finish(false);
  });
}
